<app-capture-history-item-title>
  Capture Record Created
</app-capture-history-item-title>

<app-capture-history-item-body>
  @if (captureSnapshot.processing) {
    <span> Processing... </span>
  } @else {
    @if (canDownload) {
      <a href="#" (click)="onDownloadClick($event)">
        {{ captureSnapshot.filename }}
      </a>
    } @else {
      <span> {{ captureSnapshot.status | titlecase }} </span>
    }
  }
</app-capture-history-item-body>
